import React from "react";
import { CssVarsProvider, extendTheme } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import type { ReactNode } from "react";

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        // Brand green scale (was a half-edited template blue scale with a
        // "##4CAF50" typo, so Joy-styled controls drifted off-brand).
        primary: {
          50: "#E8F5E9",
          100: "#C8E6C9",
          200: "#A5D6A7",
          300: "#81C784",
          400: "#66BB6A",
          500: "#2E7D32",
          600: "#2E7D32",
          700: "#1B5E20",
          800: "#194D19",
          900: "#103B10",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          50: "#f0f7ff",
          100: "#c2e0ff",
          200: "#99ccf3",
          300: "#66b2ff",
          400: "#3399ff",
          500: "#007fff",
          600: "#0072e5",
          700: "#0059B2",
          800: "#004c99",
          900: "#003a75",
        },
      },
    },
  },
});

export function JoyThemeProvider({ children }: { children: ReactNode }) {
  return (
    <CssVarsProvider theme={theme} defaultMode="light">
      <CssBaseline />
      {children}
    </CssVarsProvider>
  );
}
